/* eslint-disable */
export default {
  logging: 'Protokollierung...',
  logCall: 'Anruf protokollieren',
  editLog: 'Protokoll bearbeiten',
  select: 'Übereinstimmenden Datensatz auswählen',
  OnHold: 'Wird gehalten',
  Ringing: 'Läutet',
  CallConnected: 'Anruf verbunden',
  unknownUser: 'Unbekannter Benutzer',
  unknownNumber: 'Anonym',
  unavailable: 'Nicht verfügbar',
  viewDetails: 'Details anzeigen',
  addEntity: 'Neu erstellen',
  addLog: 'Protokoll',
  text: 'Text',
  call: 'Anruf',
  missedCall: 'Verpasste',
  inboundCall: 'Eingehend',
  outboundCall: 'Ausgehend',
  answeredBy: 'Beantwortet von',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
